module.exports = __webpack_public_path__ + "img/img03.2a6fd54f.svg";